const itemFilesActions = {
  ITEM_FILES_SET: 'ITEM_FILES_SET',
  ITEM_FILES_UPDATE: 'ITEM_FILES_UPDATE',
  ITEM_FILES_ADD: 'ITEM_FILES_ADD',
  ITEM_FILES_SUBSTITUTE: 'ITEM_FILES_SUBSTITUTE',
  ITEM_FILES_DELETE: 'ITEM_FILES_ DELETE'
};
export default itemFilesActions;
